module.exports = __webpack_public_path__ + "static/blog35-40d656725e44628bd8d0ae2fea412190.png";